export default "__VITE_ASSET__Dfpe7koz__"